var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconExpandDown = function () { return (_jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "12", cy: "12", r: "12", fill: "#320B42" }), _jsx("rect", { width: "16", height: "16", transform: "translate(20.0215 20.9883) rotate(179.922)", fill: "#320B42" }), _jsx("path", { d: "M7.61354 10.5607C7.93185 10.2508 8.43887 10.2501 8.75802 10.5591L12.0109 13.7091L15.2552 10.5503C15.5735 10.2404 16.0805 10.2397 16.3997 10.5488C16.7324 10.871 16.7331 11.4043 16.4013 11.7274L12.7097 15.3217C12.3222 15.699 11.705 15.6998 11.3164 15.3236L7.61514 11.7393C7.28243 11.4172 7.28171 10.8838 7.61354 10.5607Z", fill: "white" })] }))); };
